module.exports = __webpack_public_path__ + "static/media/ling-puzzles-logo-puzzle.7d63c69c.png";